import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PureComponent, Fragment } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExTooltip from 'visitor-ui-component-library/tooltip/VizExTooltip';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGAttach from 'visitor-ui-component-library-icons/icons/SVGAttach';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HiddenInput = styled.input.withConfig({
  displayName: "AttachmentPickerButton__HiddenInput",
  componentId: "sc-1ecb91c-0"
})(["display:none;"]);
class AttachmentPickerButton extends PureComponent {
  constructor(props) {
    super(props);
    this.inputRefCallback = ref => {
      this.inputRef = ref;
    };
    this.findInputNode = () => {
      if (!this.inputRef) {
        return null;
      }
      const inputNode = ReactDOM.findDOMNode(this.inputRef);
      return inputNode;
    };
    this.clearInputNode = () => {
      const inputNode = this.findInputNode();
      if (inputNode) {
        inputNode.value = '';
      }
    };
    this.handlePickerClick = e => {
      const inputNode = this.findInputNode();
      if (inputNode) {
        inputNode.click();
      }
      this.props.onClick(e);
    };
    this.onInputChange = ({
      target: {
        files
      }
    }) => {
      this.props.onSelectFiles({
        files
      });
      this.clearInputNode();
    };
    this.renderMaxFileSizeTooltip = () => {
      if (this.props.mobile) {
        return undefined;
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-ui.fileSizeLimit",
        options: {
          size: I18n.formatSize(this.props.maxAttachmentFileSize)
        }
      });
    };
    this.inputRef = null;
  }
  render() {
    const {
      disabled
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(VizExTooltip, {
        content: this.renderMaxFileSizeTooltip(),
        placement: "top right",
        children: /*#__PURE__*/_jsx(VizExIconButton, {
          disabled: disabled,
          onClick: this.handlePickerClick,
          use: "transparent-on-background",
          "aria-label": I18n.text('conversations-visitor-ui.visitorExperienceAriaLabels.attachment'),
          shape: "circle",
          "data-test-id": "AttachmentPickerButton-VizExIconButton",
          children: /*#__PURE__*/_jsx(VizExIcon, {
            icon: /*#__PURE__*/_jsx(SVGAttach, {})
          })
        })
      }), /*#__PURE__*/_jsx(HiddenInput, {
        accept: this.props.accept.join(','),
        "data-selenium-test": "visitor-attachment-file-input",
        "data-test-id": "AttachmentPickerButton-input",
        disabled: this.props.disabled,
        ref: this.inputRefCallback,
        type: "file",
        multiple: this.props.allowMultiple,
        onChange: this.onInputChange
      })]
    });
  }
}
AttachmentPickerButton.displayName = 'AttachmentPickerButton';
AttachmentPickerButton.defaultProps = {
  accept: [],
  allowMultiple: false,
  onClick: () => {}
};
export default AttachmentPickerButton;